import { ListItem } from "arkh";
import { WorkspaceSignalItemRowContainer } from "./WorkspaceSignalItemRowContainer";
import { SortableColumnTitle } from "../SortableColumnTitle";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export type WorkspaceSignalSortKey =
  | "priority"
  | "description"
  | "filter"
  | "published"
  | "topic";

export type WorkspaceSignalOrder = {
  column: WorkspaceSignalSortKey;
  order: "ASC" | "DESC";
};
export function WorkspaceSignalHeader(props: {
  onOrderChange: (newOrder: WorkspaceSignalOrder) => void;
  order: WorkspaceSignalOrder;
  showTopics: boolean;
}) {
  const order = props.order;

  const propsForColumn = (column: WorkspaceSignalSortKey) => {
    return {
      order: order.column === column ? order.order : null,
      onOrderChange: () => {
        props.onOrderChange({
          column,
          order: order.order === "ASC" ? "DESC" : "ASC",
        });
      },
      onOrderBySelect: () => {
        props.onOrderChange({
          column,
          order: "DESC",
        });
      },
    };
  };

  const intl_tokens = useIntlTokens();

  return (
    <ListItem border="border-primary" displayMode="TABLE">
      <WorkspaceSignalItemRowContainer
        priority={
          <SortableColumnTitle
            title={intl_tokens.Prio}
            {...propsForColumn("priority")}
          />
        }
        description={
          <SortableColumnTitle
            title={intl_tokens.Description}
            {...propsForColumn("description")}
          />
        }
        published={
          <SortableColumnTitle
            title={intl_tokens.Published}
            {...propsForColumn("published")}
          />
        }
        topic={
          props.showTopics ? (
            <SortableColumnTitle
              title={intl_tokens.Topic}
              {...propsForColumn("topic")}
            />
          ) : null
        }
        more={null}
      />
    </ListItem>
  );
}
